import articlePresetPicture, { transform, } from '@media-ui/pypo-article/src/containers/Article/presets/articlePresetPicture';
import type { IGalleryShowManager } from 'Src/hooks/useShowGallery/useShowGallery.types';
export const presetPicture = (galleryShowManager: IGalleryShowManager) => articlePresetPicture((presetProps) => {
    const { Component: Picture } = presetProps;
    const data = presetProps.data;
    const imageProps = transform(data);
    const { pictureProps } = imageProps;
    if (imageProps.source === 'Неизвестный источник') {
        imageProps.source = '';
    }
    const isLargePicture = 'large' in data.data && !data.attrs.extractFromGallery;
    /**
     * Вешаем обработчик открытия галереи только на большие картинки
     * и картинки, которые можно объединять в галеререи
     */
    if (isLargePicture && 'key' in pictureProps && !data.attrs.disabledZoom) {
        const dispatcher = galleryShowManager(pictureProps['key'] as string);
        if (dispatcher) {
            imageProps['onGalleryOpen'] = dispatcher;
        }
    }
    return <Picture {...imageProps}/>;
});
